import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VLayout,{attrs:{"justify-center":""}},[_c(VFlex,{attrs:{"xs12":"","sm8":"","md6":""}},[_c(VCard,[_c(VCardTitle,{staticClass:"justify-center"},[_vm._v("Great Job!")]),_c(VCardText,[_c('VerifyPhone',{attrs:{"phone-number":_vm.adminPhoneNumber},on:{"verified":_vm.submit}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }